import React from "react";
import { useFullscreen } from "../hooks/useFullscreen";

function IconButton({ icon, label, onClick, active, tour, extra = '' }) {
    return (
        <button
            type="button"
            className={`btn-circular main-buttons button-icon d-flex align-items-center${extra ? ` ${extra}` : ''}${active ? ' is-active' : ''}`}
            aria-label={label}
            aria-pressed={active === undefined ? undefined : active}
            data-tour={tour}
            onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                if (onClick) onClick(e);
            }}
        >
            <i className="material-icons">{icon}</i>
        </button>
    );
}

// Toolbar: next film, search, table, fullscreen, mute, report, home (+ rate for raters).
// Panel buttons open their panel; the one that is already open does nothing. Home closes it.
export default function Buttons({
    hideVideo,
    getNextMovie,
    showMovieInfo,
    toggleMute,
    mute,
    openSearch,
    openMovieTable,
    openReport,
    openRecommend,
    goHome,
    searchVisible,
    tableVisible,
    reportingVisible,
    recommendVisible,
    homeActive,
    showTableButton = true,
    showRateButton = false,
}) {
    const { requestFullscreen } = useFullscreen();

    const stopPropagation = (e) => {
        e.stopPropagation();
        e.preventDefault();
    };

    const next = () => {
        if (typeof hideVideo === 'function') hideVideo();
        showMovieInfo();
        getNextMovie();
    };

    return (
        <div className="row buttons-container" onClick={stopPropagation} onMouseDown={stopPropagation}>
            <IconButton icon="navigate_next" label="Next film" tour="next" onClick={next} />
            <IconButton icon="search" label="Search" tour="search" extra="btn-search" active={searchVisible} onClick={openSearch} />
            {showTableButton ? (
                <IconButton icon="table_chart" label="Table" tour="table" active={tableVisible} onClick={openMovieTable} />
            ) : null}
            {showTableButton ? (
                <IconButton icon="fullscreen" label="Fullscreen" extra="btn-fullscreen" onClick={requestFullscreen} />
            ) : null}
            <IconButton icon={mute ? 'volume_off' : 'volume_up'} label={mute ? 'Unmute' : 'Mute'} onClick={toggleMute} />
            <IconButton icon="report" label="Report trailer" active={reportingVisible} onClick={openReport} />
            <IconButton icon="home" label="Home" tour="home" active={homeActive} onClick={goHome} />
            {showRateButton ? (
                <IconButton icon="star_outline" label="Rate" extra="btn-recommend" active={recommendVisible} onClick={openRecommend} />
            ) : null}
        </div>
    );
}
